import { Injectable } from '@angular/core';

import { ThirdPartyShipperAccount } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ThirdPartyShipperAccountService extends TmsWebBaseEditService<
  ThirdPartyShipperAccount,
  ThirdPartyShipperAccount
> {
  constructor() {
    super('ThirdPartyShipperAccount', $localize`Third Party Shipper Account`);
  }
}
